/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupedScreeningsDto } from '../../models/grouped-screenings-dto';

export interface ListByProcess$Params {
  kycProcessId: string;
}

export function listByProcess(http: HttpClient, rootUrl: string, params: ListByProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GroupedScreeningsDto>>> {
  const rb = new RequestBuilder(rootUrl, listByProcess.PATH, 'get');
  if (params) {
    rb.query('kycProcessId', params.kycProcessId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GroupedScreeningsDto>>;
    })
  );
}

listByProcess.PATH = '/screenings';
